import Landing from "../views/Landing";

const routes = [{
    path: '/',
    name: 'Home',
    component: Landing
},
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about/AboutInstitute.vue')

    },
    {
        path: '/with-sidebar',
        name: 'WithSidebar',
        component: () => import('@/views/WithSidebar.vue')

    },
    {
        path: '/principal-desk',
        name: 'PrincipalDesk',
        component: () => import('@/views/about/PrincipalDesk')
    },
    {
        path: '/secretary-message',
        name: 'SecretaryMessage',
        component: () => import('@/views/about/SecretaryMessage')
    },
    {
        path: '/vision-mission',
        name: 'AboutVision',
        component: () => import('@/views/about/VisionMission')
    },
    {
        path: '/governing-body',
        name: 'GovernanceBody',
        component: () => import('@/views/about/GoverningBody')
    },
    {
        path: '/grievance-redressal',
        name: 'GrievanceRedressal',
        component: () => import('@/views/about/GrievanceRedressal')
    },
    /**
     * Governance
     */
    {
        path: '/governance',
        name: 'Governance',
        component: () => import('@/views/about/governance/Governance')
    },
    {
        path: '/governance/clg-development-committee',
        name: 'CollegeDevelopmentCommittee',
        component: () => import('@/views/about/governance/CollegeDevCom.vue')
    },
    /**
     * Computer Department
     */
    {
        path: '/academics/computer/about',
        name: 'ComputerAbout',
        component: () => import('@/views/academics/computer/About')
    },
    {
        path: '/academics/computer/vision-mission',
        name: 'ComputerVision',
        component: () => import('@/views/academics/computer/VisionMission')
    },
    {
        path: '/academics/computer/peo-po',
        name: 'ComputerPeo',
        component: () => import('@/views/academics/computer/PosPeos')
    },
    {
        path: '/academics/computer/faculty',
        name: 'ComputerFaculty',
        component: () => import('@/views/academics/computer/Faculty')
    },
    {
        path: '/academics/computer/academic-calender',
        name: 'ComputerAcademicCalender',
        component: () => import('@/views/academics/computer/AcademicCalender')
    },
    {
        path: '/academics/computer/infrastructure',
        name: 'ComputerInfrastructure',
        component: () => import('@/views/academics/computer/Infrastructure')
    },
    {
        path: '/academics/computer/academic-achievers',
        name: 'ComputerAcademicAchievers',
        component: () => import('@/views/academics/computer/AcademicAchievers')
    }, {
        path: '/academics/computer/result-analysis',
        name: 'ComputerResultAnalysis',
        component: () => import('@/views/academics/computer/ResultAnalysis')
    },
    {
        path: '/academics/computer/achievements',
        name: 'ComputerAchievements',
        component: () => import('@/views/academics/computer/Achievements')
    },
    {
        path: '/academics/computer/students-club',
        name: 'ComputerStudentClub',
        component: () => import('@/views/academics/computer/StudentsClub')
    },
    {
        path: '/academics/computer/social-activities',
        name: 'ComputerSocialActivities',
        component: () => import('@/views/academics/computer/SocialActivities')
    },
    {
        path: '/academics/computer/news-events',
        name: 'ComputerNewsEvents',
        component: () => import('@/views/academics/computer/NewsEvents')
    },
    {
        path: '/academics/computer/syllabus',
        name: 'ComputerSyllabus',
        component: () => import('@/views/academics/computer/Syllabus')
    },
    {
        path: '/academics/computer/gallery',
        name: 'ComputerGallery',
        component: () => import('@/views/academics/computer/Gallery')
    },
    /**
     * Civil Department
     */
    {
        path: '/academics/civil/about',
        name: 'CivilAbout',
        component: () => import('@/views/academics/civil/About')
    },
    {
        path: '/academics/civil/vision-mission',
        name: 'CivilVision',
        component: () => import('@/views/academics/civil/VisionMission')
    },
    {
        path: '/academics/civil/peo-po',
        name: 'CivilPeo',
        component: () => import('@/views/academics/civil/PosPeos')
    },
    {
        path: '/academics/civil/faculty',
        name: 'CivilFaculty',
        component: () => import('@/views/academics/civil/Faculty')
    },
    {
        path: '/academics/civil/academic-calender',
        name: 'CivilAcademicCalender',
        component: () => import('@/views/academics/civil/AcademicCalender')
    },
    {
        path: '/academics/civil/infrastructure',
        name: 'CivilInfrastructure',
        component: () => import('@/views/academics/civil/Infrastructure')
    },
    {
        path: '/academics/civil/academic-achievers',
        name: 'CivilAcademicAchievers',
        component: () => import('@/views/academics/civil/AcademicAchievers')
    },
    {
        path: '/academics/civil/result-analysis',
        name: 'CivilResultAnalysis',
        component: () => import('@/views/academics/civil/ResultAnalysis')
    },
    {
        path: '/academics/civil/achievements',
        name: 'CivilAchievements',
        component: () => import('@/views/academics/civil/Achievements')
    },
    {
        path: '/academics/civil/students-club',
        name: 'CivilStudentClub',
        component: () => import('@/views/academics/civil/StudentsClub')
    },
    {
        path: '/academics/civil/social-activities',
        name: 'CivilSocialActivities',
        component: () => import('@/views/academics/civil/SocialActivities')
    },
    {
        path: '/academics/civil/news-events',
        name: 'CivilNewsEvents',
        component: () => import('@/views/academics/civil/NewsEvents')
    },
    {
        path: '/academics/civil/syllabus',
        name: 'CivilSyllabus',
        component: () => import('@/views/academics/civil/Syllabus')
    },
    {
        path: '/academics/civil/gallery',
        name: 'CivilGallery',
        component: () => import('@/views/academics/civil/Gallery')
    },
    /**
     * Electrical Department
     */
    {
        path: '/academics/electrical/about',
        name: 'ElectricalAbout',
        component: () => import('@/views/academics/electrical/About')
    },
    {
        path: '/academics/electrical/vision-mission',
        name: 'ElectricalVision',
        component: () => import('@/views/academics/electrical/VisionMission')
    },
    {
        path: '/academics/electrical/peo-po',
        name: 'ElectricalPeo',
        component: () => import('@/views/academics/electrical/PosPeos')
    },
    {
        path: '/academics/electrical/faculty',
        name: 'ElectricalFaculty',
        component: () => import('@/views/academics/electrical/Faculty')
    },
    {
        path: '/academics/electrical/academic-calender',
        name: 'ElectricalAcademicCalender',
        component: () => import('@/views/academics/electrical/AcademicCalender')
    },
    {
        path: '/academics/electrical/infrastructure',
        name: 'ElectricalInfrastructure',
        component: () => import('@/views/academics/electrical/Infrastructure')
    },
    {
        path: '/academics/electrical/academic-achievers',
        name: 'ElectricalAcademicAchievers',
        component: () => import('@/views/academics/electrical/AcademicAchievers')
    },
    {
        path: '/academics/electrical/result-analysis',
        name: 'ElectricalResultAnalysis',
        component: () => import('@/views/academics/electrical/ResultAnalysis')
    },
    {
        path: '/academics/electrical/achievements',
        name: 'ElectricalAchievements',
        component: () => import('@/views/academics/electrical/Achievements')
    },
    {
        path: '/academics/electrical/students-club',
        name: 'ElectricalStudentClub',
        component: () => import('@/views/academics/electrical/StudentsClub')
    },
    {
        path: '/academics/electrical/social-activities',
        name: 'ElectricalSocialActivities',
        component: () => import('@/views/academics/electrical/SocialActivities')
    },
    {
        path: '/academics/electrical/news-events',
        name: 'ElectricalNewsEvents',
        component: () => import('@/views/academics/electrical/NewsEvents')
    },
    {
        path: '/academics/electrical/syllabus',
        name: 'ElectricalSyllabus',
        component: () => import('@/views/academics/electrical/Syllabus')
    },
    {
        path: '/academics/electrical/gallery',
        name: 'ElectricalGallery',
        component: () => import('@/views/academics/electrical/Gallery')
    },
    /**
     * Electronics Department
     */
    {
        path: '/academics/electronics/about',
        name: 'ElectronicsAbout',
        component: () => import('@/views/academics/electronics/About')
    },
    {
        path: '/academics/electronics/vision-mission',
        name: 'ElectronicsVision',
        component: () => import('@/views/academics/electronics/VisionMission')
    },
    {
        path: '/academics/electronics/peo-po',
        name: 'ElectronicsPeo',
        component: () => import('@/views/academics/electronics/PosPeos')
    },
    {
        path: '/academics/electronics/faculty',
        name: 'ElectronicsFaculty',
        component: () => import('@/views/academics/electronics/Faculty')
    },
    {
        path: '/academics/electronics/academic-calender',
        name: 'ElectronicsAcademicCalender',
        component: () => import('@/views/academics/electronics/AcademicCalender')
    },
    {
        path: '/academics/electronics/infrastructure',
        name: 'ElectronicsInfrastructure',
        component: () => import('@/views/academics/electronics/Infrastructure')
    },
    {
        path: '/academics/electronics/academic-achievers',
        name: 'ElectronicsAcademicAchievers',
        component: () => import('@/views/academics/electronics/AcademicAchievers')
    },
    {
        path: '/academics/electronics/result-analysis',
        name: 'ElectronicsResultAnalysis',
        component: () => import('@/views/academics/electronics/ResultAnalysis')
    },
    {
        path: '/academics/electronics/achievements',
        name: 'ElectronicsAchievements',
        component: () => import('@/views/academics/electronics/Achievements')
    },
    {
        path: '/academics/electronics/students-club',
        name: 'ElectronicsStudentClub',
        component: () => import('@/views/academics/electronics/StudentsClub')
    },
    {
        path: '/academics/electronics/social-activities',
        name: 'ElectronicsSocialActivities',
        component: () => import('@/views/academics/electronics/SocialActivities')
    },
    {
        path: '/academics/electronics/news-events',
        name: 'ElectronicsNewsEvents',
        component: () => import('@/views/academics/electronics/NewsEvents')
    },
    {
        path: '/academics/electronics/syllabus',
        name: 'ElectronicsSyllabus',
        component: () => import('@/views/academics/electronics/Syllabus')
    },
    {
        path: '/academics/electronics/gallery',
        name: 'ElectronicsGallery',
        component: () => import('@/views/academics/electronics/Gallery')
    },
    /**
     * IT Department
     */
    {
        path: '/academics/it/about',
        name: 'ItAbout',
        component: () => import('@/views/academics/it/About')
    },
    {
        path: '/academics/it/vision-mission',
        name: 'ItVision',
        component: () => import('@/views/academics/it/VisionMission')
    },
    {
        path: '/academics/it/peo-po',
        name: 'ItPeo',
        component: () => import('@/views/academics/it/PosPeos')
    },
    {
        path: '/academics/it/faculty',
        name: 'ItFaculty',
        component: () => import('@/views/academics/it/Faculty')
    },
    {
        path: '/academics/it/academic-calender',
        name: 'ItAcademicCalender',
        component: () => import('@/views/academics/it/AcademicCalender')
    },
    {
        path: '/academics/it/infrastructure',
        name: 'ItInfrastructure',
        component: () => import('@/views/academics/it/Infrastructure')
    },
    {
        path: '/academics/it/academic-achievers',
        name: 'ItAcademicAchievers',
        component: () => import('@/views/academics/it/AcademicAchievers')
    },
    {
        path: '/academics/it/result-analysis',
        name: 'ItResultAnalysis',
        component: () => import('@/views/academics/it/ResultAnalysis')
    },
    {
        path: '/academics/it/achievements',
        name: 'ItAchievements',
        component: () => import('@/views/academics/it/Achievements')
    },
    {
        path: '/academics/it/students-club',
        name: 'ItStudentClub',
        component: () => import('@/views/academics/it/StudentsClub')
    },
    {
        path: '/academics/it/social-activities',
        name: 'ItSocialActivities',
        component: () => import('@/views/academics/it/SocialActivities')
    },
    {
        path: '/academics/it/news-events',
        name: 'ItNewsEvents',
        component: () => import('@/views/academics/it/NewsEvents')
    },
    {
        path: '/academics/it/syllabus',
        name: 'ItSyllabus',
        component: () => import('@/views/academics/it/Syllabus')
    },
    {
        path: '/academics/it/gallery',
        name: 'ItGallery',
        component: () => import('@/views/academics/it/Gallery')
    },
    /**
     * Mechanical Department
     */
    {
        path: '/academics/mechanical/about',
        name: 'MechanicalAbout',
        component: () => import('@/views/academics/mechanical/About')
    },
    {
        path: '/academics/mechanical/vision-mission',
        name: 'MechanicalVision',
        component: () => import('@/views/academics/mechanical/VisionMission')
    },
    {
        path: '/academics/mechanical/peo-po',
        name: 'MechanicalPeo',
        component: () => import('@/views/academics/mechanical/PosPeos')
    },
    {
        path: '/academics/mechanical/faculty',
        name: 'MechanicalFaculty',
        component: () => import('@/views/academics/mechanical/Faculty')
    },
    {
        path: '/academics/mechanical/academic-calender',
        name: 'MechanicalAcademicCalender',
        component: () => import('@/views/academics/mechanical/AcademicCalender')
    },
    {
        path: '/academics/mechanical/infrastructure',
        name: 'MechanicalInfrastructure',
        component: () => import('@/views/academics/mechanical/Infrastructure')
    },
    {
        path: '/academics/mechanical/academic-achievers',
        name: 'MechanicalAcademicAchievers',
        component: () => import('@/views/academics/mechanical/AcademicAchievers')
    },
    {
        path: '/academics/mechanical/result-analysis',
        name: 'MechanicalResultAnalysis',
        component: () => import('@/views/academics/mechanical/ResultAnalysis')
    },
    {
        path: '/academics/mechanical/achievements',
        name: 'MechanicalAchievements',
        component: () => import('@/views/academics/mechanical/Achievements')
    },
    {
        path: '/academics/mechanical/students-club',
        name: 'MechanicalStudentClub',
        component: () => import('@/views/academics/mechanical/StudentsClub')
    },
    {
        path: '/academics/mechanical/social-activities',
        name: 'MechanicalSocialActivities',
        component: () => import('@/views/academics/mechanical/SocialActivities')
    },
    {
        path: '/academics/mechanical/news-events',
        name: 'MechanicalNewsEvents',
        component: () => import('@/views/academics/mechanical/NewsEvents')
    },
    {
        path: '/academics/mechanical/syllabus',
        name: 'MechanicalSyllabus',
        component: () => import('@/views/academics/mechanical/Syllabus')
    },
    {
        path: '/academics/mechanical/gallery',
        name: 'MechanicalGallery',
        component: () => import('@/views/academics/mechanical/Gallery')
    },
    /**
     * Engineering Science
     */
    {
        path: '/academics/science/about',
        name: 'ScienceAbout',
        component: () => import('@/views/academics/science/About')
    },
    {
        path: '/academics/science/vision-mission',
        name: 'ScienceVision',
        component: () => import('@/views/academics/science/VisionMission')
    },
    {
        path: '/academics/science/peo-po',
        name: 'SciencePeo',
        component: () => import('@/views/academics/science/PosPeos')
    },
    {
        path: '/academics/science/faculty',
        name: 'ScienceFaculty',
        component: () => import('@/views/academics/science/Faculty')
    },
    {
        path: '/academics/science/academic-calender',
        name: 'ScienceAcademicCalender',
        component: () => import('@/views/academics/science/AcademicCalender')
    },
    {
        path: '/academics/science/infrastructure',
        name: 'MechnicalInfrastructure',
        component: () => import('@/views/academics/science/Infrastructure')
    },
    {
        path: '/academics/science/academic-achievers',
        name: 'MechnicalAcademicAchievers',
        component: () => import('@/views/academics/science/AcademicAchievers')
    },
    {
        path: '/academics/science/result-analysis',
        name: 'MechnicalResultAnalysis',
        component: () => import('@/views/academics/science/ResultAnalysis')
    },
    {
        path: '/academics/science/achievements',
        name: 'ScienceAchievements',
        component: () => import('@/views/academics/science/Achievements')
    },
    {
        path: '/academics/science/students-club',
        name: 'ScienceStudentClub',
        component: () => import('@/views/academics/science/StudentsClub')
    },
    {
        path: '/academics/science/social-activities',
        name: 'ScienceSocialActivities',
        component: () => import('@/views/academics/science/SocialActivities')
    },
    {
        path: '/academics/science/news-events',
        name: 'ScienceNewsEvents',
        component: () => import('@/views/academics/science/NewsEvents')
    },
    {
        path: '/academics/science/syllabus',
        name: 'ScienceSyllabus',
        component: () => import('@/views/academics/science/Syllabus')
    },
    {
        path: '/academics/science/gallery',
        name: 'ScienceGallery',
        component: () => import('@/views/academics/science/Gallery')
    },
    /**
     * MBA Department
     */
    {
        path: '/academics/mba/about',
        name: 'MBAAbout',
        component: () => import('@/views/academics/mba/About')
    },
    {
        path: '/academics/mba/vision-mission',
        name: 'MBAVision',
        component: () => import('@/views/academics/mba/VisionMission')
    },
    {
        path: '/academics/mba/peo-po',
        name: 'MBAPeo',
        component: () => import('@/views/academics/mba/PosPeos')
    },
    {
        path: '/academics/mba/faculty',
        name: 'MBAFaculty',
        component: () => import('@/views/academics/mba/Faculty')
    },
    {
        path: '/academics/mba/academic-calender',
        name: 'MBAAcademicCalender',
        component: () => import('@/views/academics/mba/AcademicCalender')
    },
    {
        path: '/academics/mba/infrastructure',
        name: 'MBAInfrastructure',
        component: () => import('@/views/academics/mba/Infrastructure')
    },
    {
        path: '/academics/mba/academics-achievers',
        name: 'MBAAcademicsAchievers',
        component: () => import('@/views/academics/mba/AcademicAchievers')
    },
    {
        path: '/academics/mba/result-analysis',
        name: 'MBAResultAnalysis',
        component: () => import('@/views/academics/mba/ResultAnalysis')
    },
    {
        path: '/academics/mba/achievements',
        name: 'MBAAchievements',
        component: () => import('@/views/academics/mba/Achievements')
    },
    {
        path: '/academics/mba/students-club',
        name: 'MBAStudentClub',
        component: () => import('@/views/academics/mba/StudentsClub')
    },
    {
        path: '/academics/mba/social-activities',
        name: 'MBASocialActivities',
        component: () => import('@/views/academics/mba/SocialActivities')
    },
    {
        path: '/academics/mba/news-events',
        name: 'MBANewsEvents',
        component: () => import('@/views/academics/mba/NewsEvents')
    },
    {
        path: '/academics/mba/syllabus',
        name: 'MBASyllabus',
        component: () => import('@/views/academics/mba/Syllabus')
    },
    {
        path: '/academics/mba/gallery',
        name: 'MBAGallery',
        component: () => import('@/views/academics/mba/Gallery')
    },

    {
        path: '/admissions/fe',
        name: 'AdmissionsFe',
        component: () => import('@/views/admissions/FyUg')
    },
    {
        path: '/admissions/dsy',
        name: 'AdmissionsDsy',
        component: () => import('@/views/admissions/DsyUg')
    }, {
        path: '/admissions/pg',
        name: 'AdmissionsPg',
        component: () => import('@/views/admissions/Pg')
    }, {
        path: '/admissions/mba',
        name: 'AdmissionsMba',
        component: () => import('@/views/admissions/Mba')
    },
    {
        path: '/administration',
        name: 'Administration',
        component: () => import('@/views/administration/Administration')
    },
    {
        path: '/administration/staff',
        name: 'AdministrationStaff',
        component: () => import('@/views/administration/Staff')
    }, {
        path: '/administration/downloads',
        name: 'AdministrationDownloads',
        component: () => import('@/views/administration/Downloads')
    },
    {
        path: '/tpo/about',
        name: 'TpoAbout',
        component: () => import('@/views/tpo/About')
    },
    {
        path: '/tpo/goals-objectives',
        name: 'TpoGoalObjectives',
        component: () => import('@/views/tpo/GoalObjectives')
    },
    {
        path: '/tpo/team',
        name: 'TpoTeam',
        component: () => import('@/views/tpo/Team')
    }, {
        path: '/tpo/mous',
        name: 'TpoMous',
        component: () => import('@/views/tpo/Mous')
    }, {
        path: '/tpo/training-practices-facilities',
        name: 'TpoTrainingPractices',
        component: () => import('@/views/tpo/PracticesTrainings')
    }, {
        path: '/tpo/infrastructure',
        name: 'TpoInfraStructure',
        component: () => import('@/views/tpo/Infrastructure')
    }, {
        path: '/tpo/higher-education-opportunities',
        name: 'TpoHigherEducationOpportunities',
        component: () => import('@/views/tpo/HigherEducationOpportunities')
    }, {
        path: '/tpo/major-recruiters',
        name: 'TpoMajorRecruiters',
        component: () => import('@/views/tpo/MajorRecruiters')
    }, {
        path: '/tpo/placement-record',
        name: 'TpoPlacementRecord',
        component: () => import('@/views/tpo/PlacementRecord')
    }, {
        path: '/tpo/placement-rules',
        name: 'TpoPlacementRules',
        component: () => import('@/views/tpo/PlacementRules')
    }, {
        path: '/tpo/imp-links-downloads',
        name: 'TpoImpLinksDownloads',
        component: () => import('@/views/tpo/ImpLinksDownloads')
    }, {
        path: '/tpo/gallery',
        name: 'TpoGallery',
        component: () => import('@/views/tpo/Gallery')
    },
    /**
     * Alumni
     */
    {
        path: '/alumni',
        name: 'alumni',
        component: () => import('@/views/alumni/AlumniAssociation')
    },
    {
        path: '/alumni/vision-mission',
        name: 'alumni-vision-mission',
        component: () => import('@/views/alumni/VisionMission')
    },
    {
        path: '/alumni/governing-body',
        name: 'alumni-governing-body',
        component: () => import('@/views/alumni/GoverningBody')
    },
    {
        path: '/alumni/gallery',
        name: 'alumni-gallery',
        component: () => import('@/views/alumni/Gallery')
    },
    {
        path: '/alumni/list',
        name: 'alumni-lists',
        component: () => import('@/views/alumni/AlumniLists')
    },
    {
        path: '/alumni/success-stories',
        name: 'alumni-success-stories',
        component: () => import('@/views/alumni/SuccessStories')
    },

    {
        path: '/facilities/facility',
        name: 'facility',
        component: () => import('@/views/facilities/Facility')
    },

    {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import('@/views/ContactUs')
    },
    /**
     * Library
     */
    {
        path: '/library/about',
        name: 'LibraryAbout',
        component: () => import('@/views/library/About')
    },
    {
        path: '/library/digital-library',
        name: 'LibraryDigitalLibrary',
        component: () => import('@/views/library/DigitalLibrary')
    },
    {
        path: '/library/resources',
        name: 'LibraryResources',
        component: () => import('@/views/library/Resources')
    },
    {
        path: '/library/services',
        name: 'LibraryServices',
        component: () => import('@/views/library/Services')
    },
    {
        path: '/library/rules',
        name: 'LibraryRules',
        component: () => import('@/views/library/Rules')
    },
    {
        path: '/library/timings',
        name: 'LibraryTimings',
        component: () => import('@/views/library/Timings')
    },
    {
        path: '/library/committee',
        name: 'LibraryCommittee',
        component: () => import('@/views/library/Committee')
    },
    {
        path: '/library/team',
        name: 'LibraryTeam',
        component: () => import('@/views/library/Team')
    },
    {
        path: '/library/infrastructure',
        name: 'LibraryInfrastructure',
        component: () => import('@/views/library/Infrastructure')
    },
    {
        path: '/library/notices',
        name: 'LibraryNotices',
        component: () => import('@/views/library/Notices')
    },
    {
        path: '/library/downloads',
        name: 'LibraryDownloads',
        component: () => import('@/views/library/Downloads')
    },
    {
        path: '/library/gallery',
        name: 'LibraryGallery',
        component: () => import('@/views/library/Gallery')
    },
    /**
     * NSS
     */
    {
        path: '/nss',
        name: 'NSS',
        component: () => import('@/views/nss/About')
    },
    {
        path: '/nss/roles',
        name: 'NSSRoles',
        component: () => import('@/views/nss/Roles')
    },
    {
        path: '/nss/committee',
        name: 'NSSCommittee',
        component: () => import('@/views/nss/Committee')
    },
    {
        path: '/nss/objective',
        name: 'NSSObjective',
        component: () => import('@/views/nss/Objective')
    },

]


export default routes;
